import { useLocalStorage } from '@backmarket/utils/composables/useLocalStorage'

import { POPUP_TYPE } from '../LeadCollectionPopup.constants'

const STORAGE_KEY_PREFIX = 'popup_state_'
const EMAIL_COLLECTOR_KEY = `${STORAGE_KEY_PREFIX}email_collector`
const APP_DOWNLOAD_KEY = `${STORAGE_KEY_PREFIX}app_download`
const SEVEN_DAYS_IN_MS = 7 * 24 * 60 * 60 * 1000
const THREE_MONTHS_IN_MS = 90 * 24 * 60 * 60 * 1000

export const STATE = {
  CLOSED: 'closed',
  ACTIONED: 'actioned',
} as const

type PopupTypeValue = (typeof POPUP_TYPE)[keyof typeof POPUP_TYPE]
export type StateValue = (typeof STATE)[keyof typeof STATE]

function getStorageKeyForPopup(popupType: PopupTypeValue) {
  return popupType === POPUP_TYPE.EMAIL_COLLECTOR
    ? EMAIL_COLLECTOR_KEY
    : APP_DOWNLOAD_KEY
}

export function recordState(popupType: PopupTypeValue, state: StateValue) {
  const localStorage = useLocalStorage()

  const storageKey = getStorageKeyForPopup(popupType)
  const popupState = {
    state,
    timestamp: new Date().getTime(),
  }

  localStorage.setItem(storageKey, JSON.stringify(popupState))
}

export function canShowPopup(popupType: PopupTypeValue) {
  const localStorage = useLocalStorage()

  const storageKey = getStorageKeyForPopup(popupType)
  const stringState = localStorage.getItem(storageKey)

  if (!stringState) {
    // nothing prevents the popup from showing up
    return true
  }

  const storedState = JSON.parse(stringState)
  const currentTime = new Date().getTime()
  const elapsedTime = currentTime - storedState.timestamp

  switch (storedState.state) {
    case STATE.CLOSED:
      // Show again after 7 days
      return elapsedTime > SEVEN_DAYS_IN_MS

    case STATE.ACTIONED:
      // Show again after 3 months
      return elapsedTime > THREE_MONTHS_IN_MS

    default:
      return true
  }
}
